<template>
    <b-card no-body class="overflow-hidden">
        <!-- Detay görünümü -->
        <div v-if="selected" class="p-1">
            <mediation-detail :item="selected" v-on:back="selected = null" />
        </div>

        <!-- Liste görünümü -->
        <b-overlay v-else :show="getting" opacity="0.5">
            <div class="p-1">
                <div class="row align-items-center gy-50">
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.month">
                            <option :value="0">Tüm Aylar</option>
                            <option v-for="m in months" :key="m.index" :value="m.index">{{ m.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.year">
                            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <v-select-list append-to-body :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="sortBy" v-on:change="get()">
                            <option :value="0">Sıralama: Ada göre (A→Z)</option>
                            <option :value="1">Sıralama: Çıkış tarihi (yeni→eski)</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <input placeholder="Ara..." class="form-control" v-model="search" v-on:keypress.enter="get()" />
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success" v-on:click="get">Sorgula</button>
                    </div>
                </div>
            </div>
            <div class="table-responsive mb-0">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>Personel</th>
                            <th>Kimlik No</th>
                            <th>Çıkış Tarihi</th>
                            <th>Çıkış Nedeni</th>
                            <th>Şube</th>
                            <th class="text-center">Arabuluculuk</th>
                            <th class="text-right">Ödeme</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="(items || []).length == 0">
                            <tr><td colspan="8" class="text-center">Çıkışı tamamlanmış personel bulunamadı.</td></tr>
                        </template>
                        <tr v-for="(v, i) in items" :key="i">
                            <td class="text-nowrap font-weight-bold">{{ v.EmployeeFullName }}</td>
                            <td>{{ v.IdentityNumber }}</td>
                            <td>{{ v.ExitDateStr }}</td>
                            <td>{{ v.ExitCauseName }}</td>
                            <td>{{ v.BranchName }}</td>
                            <td class="text-center">
                                <span v-if="v.Arabuluculuk && v.ArabuluculukAnlasma === true" class="badge badge-light-success">Anlaşıldı</span>
                                <span v-else-if="v.Arabuluculuk && v.ArabuluculukAnlasma === false" class="badge badge-light-danger">Anlaşılamadı</span>
                                <span v-else-if="v.Arabuluculuk" class="badge badge-light-warning">Yapıldı</span>
                                <span v-else class="badge badge-light-secondary">Başlatılmadı</span>
                            </td>
                            <td class="text-right text-nowrap">
                                <span v-if="v.PaymentCount > 0">{{ v.TotalPaymentAmountStr }} <small class="text-muted">({{ v.PaymentCount }})</small></span>
                                <span v-else class="text-muted">—</span>
                            </td>
                            <td class="text-right">
                                <button class="btn btn-sm btn-primary" v-on:click="openDetail(v)">
                                    <feather-icon icon="ArrowRightIcon"/> Arabuluculuk
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="px-75 mb-1 pt-1 border-top" v-if="count > 0">
                <div class="row justify-content-md-between justify-content-center">
                    <div class="col-auto mb-1 mb-md-0">
                        <div class="d-flex align-items-center text-nowrap">
                            Toplam {{ count || 0 }} kayıt arasından
                            <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                <option v-for="pp in perPages" :key="pp" :value="pp">{{ pp }}</option>
                            </select>
                            gösteriliyor.
                        </div>
                    </div>
                    <div class="col-auto mb-1 mb-md-0">
                        <b-pagination class="mb-0" v-model="page" :total-rows="count || 0" :per-page="perPage"></b-pagination>
                    </div>
                </div>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard, BPagination, BOverlay } from "bootstrap-vue";
import CompanyApi from "@/api/company";
import moment from "moment";
import EmployeeOperationsApi from "@/api/employee-operations";
import MediationDetail from "./components/MediationDetail.vue";

export default {
    components: {
        BCard,
        BOverlay,
        BPagination,
        MediationDetail
    },
    data() {
        return {
            donem: {
                year: moment().year(),
                month: 0,
            },
            page: 1,
            perPage: 10,
            perPages: [10, 20, 30, 40, 50, 100],
            count: 0,
            years: [],
            items: [],
            getting: false,
            selected: null,
            months: [
                { index: 1, name: "Ocak" }, { index: 2, name: "Şubat" }, { index: 3, name: "Mart" },
                { index: 4, name: "Nisan" }, { index: 5, name: "Mayıs" }, { index: 6, name: "Haziran" },
                { index: 7, name: "Temmuz" }, { index: 8, name: "Ağustos" }, { index: 9, name: "Eylül" },
                { index: 10, name: "Ekim" }, { index: 11, name: "Kasım" }, { index: 12, name: "Aralık" },
            ],
            sbranches: [],
            sbranch: null,
            search: null,
            // 0 = ada göre (A→Z), 1 = çıkış tarihi (yeni→eski). Backend: ExitListSortBy.
            sortBy: 0,
        };
    },
    watch: {
        page(oldV, newV) { if (oldV && newV && oldV != newV) this.get(); },
        perPage(oldV, newV) { if (oldV && newV && oldV != newV) this.get(); },
    },
    mounted() {
        this.configureYears();
        this.getSBranches();
        this.get();
    },
    methods: {
        buildRequest(skip, take) {
            return {
                BranchTypeCode: "S",
                BranchId: this.sbranch?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
                StatusFilter: 2,
                SortBy: this.sortBy,
                PaginateRequest: {
                    IsAscending: true,
                    OrderColumnName: "",
                    QueryParam: this.search,
                    Skip: skip,
                    Take: take,
                },
            };
        },
        get() {
            this.getting = true;
            EmployeeOperationsApi.MediationCompletedExits(this.buildRequest(this.page, this.perPage))
                .then((res) => {
                    if (res.data.Success) {
                        this.items = this.$safe(res.data, "Data.Data") || [];
                        this.count = this.$safe(res.data, "Data.TotalCount") || 0;
                    }
                    this.getting = false;
                })
                .catch(() => { this.getting = false; });
        },
        getSBranches() {
            CompanyApi.Branch.ListByCode("S").then((res) => {
                this.sbranches = res.data.Data;
            });
        },
        configureYears() {
            let years = [];
            let year = moment().add(1, "year").format("YYYY");
            let firstYear = 2015;
            while (firstYear <= year) years.push(firstYear++);
            this.years = years.reverse();
        },
        openDetail(item) {
            this.selected = item;
        },
    },
};
</script>
